import { Wrapper } from "./wrapper";
import cn from "classnames";
import { ContentContainer } from "../../../../components/_shared-components/arrangement/Container";
import { css } from "@emotion/react";
import React from "react";
import { SmallLoadingSpinner } from "../../../../routes/modal-loading-spinner";

export const loadingScreen = (
  <Wrapper className={cn("expand fill-screen")}>
    <ContentContainer>
      <div
        css={css`
          display: flex;
          justify-content: center;
        `}
      >
        <SmallLoadingSpinner size={"3x"} color={"green"} />
      </div>
    </ContentContainer>
  </Wrapper>
);
